var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1542 2.33333H8.84584C7.89251 2.33333 7.11334 3.10333 7.11334 4.05667V4.91833C7.11334 5.87167 7.88334 6.64167 8.83668 6.64167H13.1542C14.1075 6.64167 14.8775 5.87167 14.8775 4.91833V4.05667C14.8867 3.10333 14.1075 2.33333 13.1542 2.33333Z",
    fill: "#39FF14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8033 4.91833C15.8033 6.37583 14.6117 7.5675 13.1542 7.5675H8.84584C7.38834 7.5675 6.19667 6.37583 6.19667 4.91833C6.19667 4.405 5.64667 4.08417 5.18834 4.3225C3.89584 5.01 3.01584 6.37583 3.01584 7.94333V16.5692C3.01584 18.8242 4.85834 20.6667 7.11334 20.6667H14.8867C17.1417 20.6667 18.9842 18.8242 18.9842 16.5692V7.94333C18.9842 6.37583 18.1042 5.01 16.8117 4.3225C16.3533 4.08417 15.8033 4.405 15.8033 4.91833ZM11.3483 16.0375H7.33334C6.95751 16.0375 6.64584 15.7258 6.64584 15.35C6.64584 14.9742 6.95751 14.6625 7.33334 14.6625H11.3483C11.7242 14.6625 12.0358 14.9742 12.0358 15.35C12.0358 15.7258 11.7242 16.0375 11.3483 16.0375ZM13.75 12.3708H7.33334C6.95751 12.3708 6.64584 12.0592 6.64584 11.6833C6.64584 11.3075 6.95751 10.9958 7.33334 10.9958H13.75C14.1258 10.9958 14.4375 11.3075 14.4375 11.6833C14.4375 12.0592 14.1258 12.3708 13.75 12.3708Z",
    fill: "#39FF14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardText);
export default __webpack_public_path__ + "static/media/clipboard-text.c333960baef4b535eae5de6924d5adcc.svg";
export { ForwardRef as ReactComponent };